<template>
  <div ref="chartMap" style="width: 100%; height: 100%"></div>
</template>

<script>
import echarts from "echarts";
import 'echarts/map/js/china.js';
export default {
  props:{
    options: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      chartMap: null,
    };
  },
  watch: {
    options: {
      deep: true,
      handler(val){
        // console.log(val,'----',this)
        // this.initChart();
        this.$nextTick(()=>{
          this.chartMap.setOption({
            series:[{
              data:val.series
            }]
          });
        })
      },
    },
  },
  mounted(){
    this.initChart();
    window.addEventListener('resize',()=>{
      if(this.chartMap){
        this.chartMap.resize()
      }
    }) ;
  },
  methods: {
    geoCoordMap(){
      return {
        包头: [110.050332, 40.582009],
        北京: [116.575347, 40.009195],
        天津: [117.258217, 39.135364],
        唐山: [118.202083, 39.547655],
        石家庄: [114.521403, 38.048292],
        太原: [112.556197, 37.876857],
        沈阳: [123.471122, 41.683657],
        大连: [121.621314, 38.919658],
        哈尔滨: [127.473135, 45.752203],
        长春: [125.330253, 43.822795],
        昆明: [103.383419, 25.64531],
        重庆: [106.575354, 29.558923],
        贵阳: [106.634858, 26.652434],
        成都: [104.072742, 30.578984],
        广州: [113.307594, 23.335625],
        南宁: [108.372958, 22.82381],
        兰州: [103.26687, 36.742196],
        西安: [108.911874, 34.166211],
        武汉: [114.348018, 30.552343],
        长沙: [113.382036, 28.533013],
        郑州: [113.45245, 34.900064],
        上海: [121.442884, 31.194772],
        杭州: [120.159428, 30.27277],
        南昌: [116.249035, 28.383532],
        南京: [118.770141, 32.067247],
        合肥: [117.8967, 31.630303],
        济南: [117.126541, 36.6584],
      };
    },
    async initChart() {
      this.chartMap = echarts.init(this.$refs.chartMap);
      let option = {
        /* tooltip:{
          formatter: function({data}) {
            if(!data) return;
            // 半年、最低点、最高点、半年平均价
            // let html = `${data.city}<br>柴油:<br>价格:${data.cyPrice.cyPrice} <br>半年最高价:${data.cyPrice.max} <br>半年最低价:${data.cyPrice.min} <br>半年平均价:${data.cyPrice.avg}<br>汽油:<br>价格:${data.qyPrice.qyPrice} <br>半年最高价:${data.qyPrice.max} <br>半年最低价:${data.qyPrice.min} <br>半年平均价:${data.qyPrice.avg}`;
            let html = `柴油:<br>价格:${data.cyPrice.cyPrice}`;
            return html;
          }
        }, */
        /* geo: {
          map: "china",
          label: {
            normal: {
              show: false,
              color:'#86e5f8',
            },
            emphasis: {
              show: false,
              color:'#fff'
            },
          },
          roam: true,
          zoom:1.2,
          itemStyle: {
            normal: {
              areaColor: "#023677",
              borderColor: "#1180c7",
            },
            emphasis: {
              areaColor: "#4499d0",
            },
          },
        }, */
        series: [
          /* {
            type: "effectScatter",
            coordinateSystem: "geo",
            data: convertData(data),
            symbolSize: 6,
            label: {
              normal: {
                show:false,
                formatter: (a)=>{
                  return `${a.name} ${a.data.value[2]}`
                },
                position: "right",
              },
              emphasis: {
                show: true,
              },
            },
            itemStyle: {
              color:'#fff550'
            },
            emphasis:{
              label: {
                normal: {
                  formatter: (a)=>{
                    return `${a.name} ${a.data.value[2]}`
                  },
                  position: "right",
                  show: true,
                },
              },
            }
          }, */
          {
            type: 'map',
            map: 'china',
            geoIndex:0,
            zoom:1.1,
            label: {
                normal: {
                  show: true,
                  color:'#fff',
                  // color:'#fb6e6c',
                  formatter(data){
                    // console.log(data)
                    if(!data.data){
                      return data.name
                    }else{
                      if(data.data.title=='汽油'){
                        // return `${data.name}\n${data.data.title}:\n${data.data.price}`
                        let type = 'val2'
                        return data.name +'\n{'+type+'|'+data.data.price+'}';
                      }else{
                        let type = 'val'
                        return data.name +'\n{'+type+'|'+data.data.price+'}';
                      }
                    }
                  },
                  rich:{
                    val:{
                      color:'#86e5f8',
                    },
                    val2:{
                      color:'#fb6e6c',
                    },
                  },
                },
                emphasis: {
                    show: false,
                    textStyle: {
                        color: '#fff'
                    }
                }
            },
            roam: true,
            itemStyle: {
              normal: {
                areaColor: "#023677",
                borderColor: "#1180c7",
              },
              emphasis: {
                areaColor: "#4499d0",
              },
            },
            animation: false,
            data: this.options.series
        },
        ],
      };
      this.chartMap.setOption(option);
    },
  },
  beforeDestroy() {
    if (!this.chartMap) {
      return;
    }
    this.chartMap.dispose();
    this.chartMap = null;
  },
};
</script>

<style lang="scss" scoped>
</style>